<script>
    export default {
        data() {
            return {
                content: this.value,
            }
        },

        props: {
            value: {
                required: true
            },

            required: {
                default: false
            },

            maxHeight: {
                /* The max height of the textarea */
                default: 'none'
            }
        },

        watch: {
            value(val) {
                this.content = val;

                this.$nextTick(() => {
                    $(this.$refs.textareaInput).trigger('autosize.resize');
                });
            },

            content: function (value) {
                this.$emit('input', value);
            },
        },

        mounted() {
            this.$nextTick(function(){
                $(this.$refs.textareaInput).autosize();
            });

            //Fix for when
            $(this.$refs.textareaInput).closest('.modal').on('shown.bs.modal',  () => {
                $(this.$refs.textareaInput).trigger('autosize.resize');
            })
        },

        methods: {
            onKeyDown (e) {
                this.$emit('keydown', e)
            }
        }
    };
</script>

<template id="textarea-autosize">
    <textarea :style="{'max-height': maxHeight}"  ref="textareaInput" v-model="content" class="textarea-autosize" :required="!!required" @keydown="onKeyDown"/>
</template>


